"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.offsetBookingToLocalMin = void 0;
const utils_1 = require("@daytrip/utils");
function offsetBookingToLocalMin(date, originLocationTimezone) {
    const originOffsetMin = (0, utils_1.getTimezoneOffsetOrDefault)(originLocationTimezone, date) / (1000 * 60);
    const localOffsetMin = date.getTimezoneOffset() * -1;
    const result = originOffsetMin - localOffsetMin;
    return result;
}
exports.offsetBookingToLocalMin = offsetBookingToLocalMin;
//# sourceMappingURL=offsetBookingToLocalMin.js.map